export const initHeaderForm = function() {
	const searchForm = document.querySelector('.main-search');
	if (searchForm) {
		const searchField = searchForm.querySelector('#search');
		const countryField = searchForm.querySelector('#search-country');

		countryField.addEventListener('change', (event) => {
			const value = event.target.value;
			window.localStorage.setItem('diagnoseo-search-country', value);
		});

		const savedCountry = window.localStorage.getItem('diagnoseo-search-country');
		if (savedCountry) {
			countryField.value = savedCountry;
		}

		searchForm && searchForm.addEventListener('submit', (event) => {
			event.preventDefault();

			let search = searchField.value;
			if (!search.trim()) {
				return;
			}
			let country = countryField.value;
			let targetUrl = '';

			const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
			const domainPattern = /^([\w-]+\.)+[\w-]{2,}$/i;

			if (!/^https?:\/\//i.test(search) && domainPattern.test(search)) {
				targetUrl = `/tools/website-visibility-checker/?domain_or_url=${search}&target_type=domain&country=${country}&from_pos=1&to_pos=100&sort_by=traffic_estimation&sort_dir=desc&results_limit=50&offset=0&start=1`;
			} else if (/^https?:\/\//i.test(search) && urlPattern.test(search)) {
				targetUrl = `/tools/website-visibility-checker/?domain_or_url=${search}&target_type=exact_url&country=${country}&from_pos=1&to_pos=100&sort_by=traffic_estimation&sort_dir=desc&results_limit=50&offset=0&start=1`;
			} else {
				targetUrl = `/tools/keyword-generator/?target-type=all-keywords&keyword=${search}&country=${country}&sort_by=search-volume&sort_dir=desc&sv_from=0&sv_to=&kd_from=0&kd_to=&search_intent=all&results_limit=50&offset=0&start=1`;
			}
			const currentLanguage = document.querySelector('html').getAttribute('lang').substring(0, 2);

			window.location = !currentLanguage || currentLanguage === 'en' ? targetUrl : `/${currentLanguage}${targetUrl}`;
		});
	}
}
